import { render } from "./AppCoverages.vue?vue&type=template&id=b67d4e36"
import script from "./AppCoverages.vue?vue&type=script&lang=js"
export * from "./AppCoverages.vue?vue&type=script&lang=js"

import "./AppCoverages.vue?vue&type=style&index=0&id=b67d4e36&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__